import { render, staticRenderFns } from "./SLoader.vue?vue&type=template&id=34dffae0&"
import script from "./SLoader.vue?vue&type=script&lang=ts&"
export * from "./SLoader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports